// extracted by mini-css-extract-plugin
export default {"actions":"Leads_actions__YKm0b","download":"Leads_download__fBEn7","link":"Leads_link__m63pf"};